import { useServices } from './useServices';

export const usePdfWorkerSrc = () => {
  return useServices().pdfWorkerSrc;
};
